import { useContext } from 'react';

import CampaignFormHeader from './components/campaignFormHeader/campaignFormHeader';
import CampaignFormSteps from './components/campaignFormSteps/campaignFormSteps';
import { CampaignFormContext } from '../../campaignForm.context';
import CampaignFormLoader from './components/campaignFormLoader/campaignFormLoader';

const CampaignFormContainer = () => {
  const { showLoader, brand, settings } = useContext(CampaignFormContext);

  return (
    <>
      {showLoader && <CampaignFormLoader />}
      {brand && settings && (
        <div className="w-full max-w-[450px] mx-auto px-5 md:px-0 pt-[60px] pb-[35px] md:pb-[120px]">
          <CampaignFormHeader />
          <CampaignFormSteps />
        </div>
      )}
    </>
  );
};

export default CampaignFormContainer;
